export const pushToDataLayer = (eventData) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
};

export const trackCalculatorUse = () => {
  pushToDataLayer({ event: 'calculator_use' });
};

export const trackLeadSubmit = (calculatedValue) => {
  pushToDataLayer({
    event: 'lead_submit',
    value: Number(calculatedValue),
    currency: 'HUF',
  });
};
